const { Component, render } = wp.element;
import App from './App.js';

render(<App />, document.getElementById('gei_contact_form'));
